export default __webpack_public_path__ + "static/media/html5.8c11e1a8.svg";